import React from 'react';
import PropTypes from 'prop-types';
import { Text, Link } from '@sitecore-jss/sitecore-jss-react';
import { H2 } from '../../theme/typography';

import {
  TileGroup,
  ButtonContainer,
  ButtonGroup,
  Icon,

} from './css';

const Tile = (props) => {
  const { fields } = props;

  const primaryLink = fields['primary link'];
  const hasPrimary = primaryLink && primaryLink.value && primaryLink.value.href;

  const secondaryLink = fields['secondary link'];
  const hasSecondary = secondaryLink && secondaryLink.value && secondaryLink.value.href;

  const readMoreLink = fields['read more link'];
  const hasReadMore = readMoreLink && readMoreLink.value && readMoreLink.value.text;

  return (
    <TileGroup>
      <Icon className="icon rectangle" />
      <H2><Text field={fields.heading} /></H2>
      <ButtonContainer>
        <ButtonGroup>
          {hasSecondary
                        && (
                        <Link field={secondaryLink} className="secondaryButton">
                          <span className="icon" />
                          {secondaryLink.value.text}
                        </Link>
                        )}
          {hasPrimary
                        && (
                        <Link field={primaryLink} className="primaryButton submit">
                          <span className="icon" />
                          {primaryLink.value.text}
                        </Link>
                        )}
        </ButtonGroup>
        {hasReadMore && readMoreLink.value.href && readMoreLink.value.href !== '/#'
                    && (
                    <ButtonGroup>
                      <a href={readMoreLink.value.href} className="secondaryButton no-border" target="_blank" rel="noopener noreferrer">
                        <span className="icon" />
                        {readMoreLink.value.text}
                      </a>
                    </ButtonGroup>
                    )}
      </ButtonContainer>

    </TileGroup>
  );
};

Tile.propTypes = {
  fields: PropTypes.shape({
    heading: PropTypes.object,
    'primary link': PropTypes.shape({
      value: PropTypes.shape({
        text: PropTypes.string,
        href: PropTypes.string,
      }),
    }),
    'secondary link': PropTypes.shape({
      value: PropTypes.shape({
        text: PropTypes.string,
        href: PropTypes.string,
      }),
    }),
    'read more link': PropTypes.shape({
      value: PropTypes.shape({
        text: PropTypes.string,
        href: PropTypes.string,
      }),
    }),
  }),
};

export default Tile;
